export const dataHooks = {
  dismissButton: 'top-banner-dismiss-button',
  content: 'top-banner-content',
  action: 'top-banner-action-container',
};
